module.exports = __webpack_public_path__ + "44d357d85cad75e445870a0437463d19.png";